import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shell-layout-errors-center',
  templateUrl: './layout-errors-center.component.html',
  styleUrls: ['./layout-errors-center.component.scss'],
})
export class LayoutErrorsCenterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
